import React from 'react';

interface LikeFilledProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string;
  strokeColor?: string;
  title?: string;
  solid?: boolean;
}

export const LikeFilled: React.FC<LikeFilledProps> = ({
  fillColor = "#3461A2",
  strokeColor = "#3461A2",
  title,
  solid,
  ...props
}) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {title && <title>{title}</title>}
    <path
      d="M5.61011 13.7624L7.93511 15.5624C8.23511 15.8624 8.91011 16.0124 9.36011 16.0124H12.2101C13.1101 16.0124 14.0851 15.3374 14.3101 14.4374L16.1101 8.96235C16.4851 7.91235 15.8101 7.01235 14.6851 7.01235H11.6851C11.2351 7.01235 10.8601 6.63735 10.9351 6.11235L11.3101 3.71235C11.4601 3.03735 11.0101 2.28735 10.3351 2.06235C9.73511 1.83735 8.98511 2.13735 8.68511 2.58735L5.61011 7.16235"
      fill={fillColor}
    />
    <path
      d="M5.61011 13.7624L7.93511 15.5624C8.23511 15.8624 8.91011 16.0124 9.36011 16.0124H12.2101C13.1101 16.0124 14.0851 15.3374 14.3101 14.4374L16.1101 8.96235C16.4851 7.91235 15.8101 7.01235 14.6851 7.01235H11.6851C11.2351 7.01235 10.8601 6.63735 10.9351 6.11235L11.3101 3.71235C11.4601 3.03735 11.0101 2.28735 10.3351 2.06235C9.73511 1.83735 8.98511 2.13735 8.68511 2.58735L5.61011 7.16235"
      stroke={strokeColor}
      fill={solid ? strokeColor : "none"}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M1.78491 13.7623V6.4123C1.78491 5.3623 2.23491 4.9873 3.28491 4.9873H4.03491C5.08491 4.9873 5.53491 5.3623 5.53491 6.4123V13.7623C5.53491 14.8123 5.08491 15.1873 4.03491 15.1873H3.28491C2.23491 15.1873 1.78491 14.8123 1.78491 13.7623Z"
      stroke={fillColor}
      fill={solid ? fillColor : "none"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
